/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const RenewFacilityPage = lazyLoad(
  () => import('./index'),
  module => module.RenewFacilityPage,
);
